export const jobsHacks = [
  {
    title: "GSOC",
    description:
      "Google Summer of Code is a global program focused on bringing more student developers into open source software development. Students work with an open source organization on a 10 week programming project during their break from school.",
    imageUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/GSoC-icon.svg/1200px-GSoC-icon.svg.png",
    type: "hackathon",
  },
  {
    imageUrl:
      "https://yt3.ggpht.com/a/AGF-l795C8OzY_enwlxE7n5CAdWlqJ_dNkfUb68HPg=s900-c-k-c0xffffffff-no-rj-mo",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Natus soluta a laborum corrupti nihil asperiores commodi mollitia! Distinctio, reiciendis error aspernatur quidem blanditiis officiis ex hic sit voluptatem nobis placeat",
    title: "Imagine Cup",
    type: "job",
  },
  {
    title: "GSOC",
    description:
      "Google Summer of Code is a global program focused on bringing more student developers into open source software development. Students work with an open source organization on a 10 week programming project during their break from school.",
    imageUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/GSoC-icon.svg/1200px-GSoC-icon.svg.png",
    type: "hackathon",
  },
  {
    imageUrl:
      "https://yt3.ggpht.com/a/AGF-l795C8OzY_enwlxE7n5CAdWlqJ_dNkfUb68HPg=s900-c-k-c0xffffffff-no-rj-mo",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Natus soluta a laborum corrupti nihil asperiores commodi mollitia! Distinctio, reiciendis error aspernatur quidem blanditiis officiis ex hic sit voluptatem nobis placeat",
    title: "Imagine Cup",
    type: "job",
  },
  {
    title: "GSOC",
    description:
      "Google Summer of Code is a global program focused on bringing more student developers into open source software development. Students work with an open source organization on a 10 week programming project during their break from school.",
    imageUrl:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/GSoC-icon.svg/1200px-GSoC-icon.svg.png",
    type: "hackathon",
  },
  {
    imageUrl:
      "https://yt3.ggpht.com/a/AGF-l795C8OzY_enwlxE7n5CAdWlqJ_dNkfUb68HPg=s900-c-k-c0xffffffff-no-rj-mo",
    description:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Natus soluta a laborum corrupti nihil asperiores commodi mollitia! Distinctio, reiciendis error aspernatur quidem blanditiis officiis ex hic sit voluptatem nobis placeat",
    title: "Imagine Cup",
    type: "job",
  },
];
